import { css } from "@styled-system/css";

export const conditionsDropdownClass = css({
	my: "16",
	height: "auto",
});
